import { render, staticRenderFns } from "./Projekterfassunguebersichtsliste.vue?vue&type=template&id=45038156&"
import script from "./Projekterfassunguebersichtsliste.vue?vue&type=script&lang=js&"
export * from "./Projekterfassunguebersichtsliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports